import DailyGoals from './DailyGoals';
export default DailyGoals;
